import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import AccountForm from "routes/constant_contact/components/AccountForm";

const AccountModal = ({ account, open, onOpenChange, onSuccess }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const actualOpen = isControlled ? open : internalOpen;
  const setOpen = isControlled ? onOpenChange : setInternalOpen;

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const header = `${account ? "Edit" : "New"} Account`;

  return (
    <Dialog open={actualOpen} onOpenChange={setOpen}>
      {!isControlled && (
        <DialogTrigger render={<Button size="sm">New Account</Button>} />
      )}
      <DialogContent>
        <DialogTitle>{header}</DialogTitle>
        <AccountForm
          model={account}
          onSuccess={handleSuccess}
          onCancel={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AccountModal;
